import connector from '@/utils/Connection'

export default {
  actions: {
    async loadServerVersion ({dispatch, commit}) {
      const result = await connector.getServerVersion();
      this.state.serverVersion = result.error == 0 ? result.data : "Нет данных";
      return result;
    }
  }
}